import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { Consent } from '@mmx/shared'

@Component({
  selector: 'mmx-consent-dialog',
  templateUrl: './consentTerms.dialog.component.html',
  styleUrls: ['../terms-dialog/terms-dialog.component.scss'],
  standalone: false,
})
export class ConsentTermsDialogComponent implements OnInit {
  @ViewChild('content', { static: true }) content: ElementRef

  acceptedConsents: boolean
  consentsLoaded = false
  consent: Consent
  consentRead: boolean

  constructor(
    public dialogRef: MatDialogRef<ConsentTermsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.consent = data.consent
  }

  ngOnInit() {
    if (this.consent.scrollRequired) {
      const element = this.content.nativeElement

      // if the consent area cannot be scrolled, then the scrollToBottom will never fire
      if (
        element.offsetHeight <= element.scrollHeight ||
        element.offsetWidth <= element.scrollWidth
      ) {
        this.consentRead = true
      }
    }
  }

  onScrollToBottom() {
    if (this.consent.scrollRequired) {
      this.consentRead = true
    }
  }
}
